
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M474.5 90h-30v90h60v-60c0-16.57-13.43-30-30-30z","fill":"#ffa436"}}),_c('path',{attrs:{"d":"M474.5 120l-90 120H7.5V60c0-16.57 13.43-30 30-30h146.07c7.96 0 15.59 3.16 21.22 8.79L256 90h188.5c16.57 0 30 13.43 30 30z","fill":"#ffbc2b"}}),_c('path',{attrs:{"d":"M444.5 120l-60 75h90v-75z","fill":"#8ae7ff"}}),_c('path',{attrs:{"d":"M444.5 120v150l-407-120v-30z","fill":"#bdf2ff"}}),_c('path',{attrs:{"d":"M37.5 150h290.93v90H37.5z","fill":"#fff"}}),_c('path',{attrs:{"d":"M474.5 150l-30 30v302h30c16.57 0 30-13.43 30-30V180c0-16.57-13.43-30-30-30z","fill":"#ffbc2b"}}),_c('path',{attrs:{"d":"M474.5 150v302c0 16.57-13.43 30-30 30h-407c-16.57 0-30-13.43-30-30V240c0-16.57 13.43-30 30-30H256l51.21-51.21a30.003 30.003 0 0121.22-8.79z","fill":"#ffcf66"}}),_c('path',{attrs:{"d":"M474.5 82.5H259.106L210.09 33.483C203.006 26.4 193.589 22.5 183.573 22.5H37.5C16.822 22.5 0 39.322 0 60v392c0 20.678 16.822 37.5 37.5 37.5h437c20.678 0 37.5-16.822 37.5-37.5V120c0-20.678-16.822-37.5-37.5-37.5zm-437-45h146.073c6.01 0 11.66 2.34 15.91 6.59l51.213 51.213A7.5 7.5 0 00256 97.5h218.5c12.406 0 22.5 10.093 22.5 22.5v30.021a37.342 37.342 0 00-15-6.766V120a7.5 7.5 0 00-7.5-7.5h-437A7.5 7.5 0 0030 120v83.255a37.342 37.342 0 00-15 6.766V60c0-12.407 10.094-22.5 22.5-22.5zm60 105c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h200.393l-44.999 45H45v-45h22.5c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5H45v-15h422v15zM497 452c0 12.407-10.094 22.5-22.5 22.5h-437C25.094 474.5 15 464.407 15 452V240c0-12.407 10.094-22.5 22.5-22.5H256c1.989 0 3.896-.79 5.304-2.197l51.212-51.213a22.356 22.356 0 0115.911-6.59H474.5c12.406 0 22.5 10.093 22.5 22.5z"}})])
          )
        }
      }
    